export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '0500d6e2-13e0-49b7-a93f-af995537abaf';
export const MODAL_CLOSE_SEC = 2.5;
